var _rect, _rect2, _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5, _circle5, _path6, _circle6, _path7, _circle7, _path8, _circle8, _path9, _circle9, _path10, _circle10, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path11, _circle11, _path12, _circle12, _path13, _circle13, _path14, _circle14, _path15, _circle15, _path16, _circle16, _path17, _circle17, _path18, _circle18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunctionalDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 367,
    viewBox: "0 0 533 367",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56.8257,
    y: 175.213,
    width: 116.019,
    height: 44.9871,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.2969,
    y: 161.006,
    width: 134.961,
    height: 59.1935,
    fill: "#14D3A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M200.845 4.70823C202.212 2.13529 205.44 1.20891 207.963 2.6656C210.484 4.12142 211.297 7.37748 209.755 9.84736L204.1 18.9064C202.738 21.0883 199.892 21.7985 197.664 20.5124C195.438 19.2272 194.629 16.4098 195.835 14.1396L200.845 4.70823Z",
    fill: "url(#paint0_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 205.428,
    cy: 7.07598,
    r: 4.61871,
    fill: "#3700D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M232.715 4.70823C234.082 2.13529 237.31 1.20891 239.833 2.6656C242.354 4.12142 243.167 7.37748 241.625 9.84736L235.97 18.9064C234.608 21.0883 231.762 21.7985 229.534 20.5124C227.308 19.2272 226.5 16.4098 227.705 14.1396L232.715 4.70823Z",
    fill: "url(#paint1_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.3,
    cy: 7.07598,
    r: 4.61871,
    fill: "#3700D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M264.586 4.70823C265.952 2.13529 269.18 1.20891 271.703 2.6656C274.225 4.12142 275.038 7.37748 273.496 9.84736L267.84 18.9064C266.478 21.0883 263.632 21.7985 261.405 20.5124C259.179 19.2272 258.37 16.4098 259.576 14.1396L264.586 4.70823Z",
    fill: "url(#paint2_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.169,
    cy: 7.07598,
    r: 4.61871,
    fill: "#3700D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M296.456 4.70823C297.823 2.13529 301.051 1.20891 303.574 2.6656C306.096 4.12142 306.908 7.37748 305.366 9.84736L299.711 18.9064C298.349 21.0883 295.503 21.7985 293.275 20.5124C291.049 19.2272 290.241 16.4098 291.447 14.1396L296.456 4.70823Z",
    fill: "url(#paint3_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.04,
    cy: 7.07598,
    r: 4.61871,
    fill: "#3700D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M328.326 4.70823C329.693 2.13529 332.921 1.20891 335.444 2.6656C337.966 4.12142 338.778 7.37748 337.236 9.84736L331.581 18.9064C330.219 21.0883 327.373 21.7985 325.146 20.5124C322.919 19.2272 322.111 16.4098 323.317 14.1396L328.326 4.70823Z",
    fill: "url(#paint4_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.909,
    cy: 7.07598,
    r: 4.61871,
    fill: "#3700D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M200.845 33.667C202.212 31.094 205.44 30.1677 207.963 31.6243C210.484 33.0802 211.297 36.3362 209.755 38.8061L204.1 47.8651C202.738 50.047 199.892 50.7573 197.664 49.4712C195.438 48.1859 194.629 45.3685 195.835 43.0983L200.845 33.667Z",
    fill: "url(#paint5_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.428,
    cy: 36.0347,
    r: 4.61871,
    fill: "#3700D3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M232.715 33.667C234.082 31.094 237.31 30.1677 239.833 31.6243C242.354 33.0802 243.167 36.3362 241.625 38.8061L235.97 47.8651C234.608 50.047 231.762 50.7573 229.534 49.4712C227.308 48.1859 226.5 45.3685 227.705 43.0983L232.715 33.667Z",
    fill: "url(#paint6_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.3,
    cy: 36.0347,
    r: 4.61871,
    fill: "#3700D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M264.586 33.667C265.952 31.094 269.18 30.1677 271.703 31.6243C274.225 33.0802 275.038 36.3362 273.496 38.8061L267.84 47.8651C266.478 50.047 263.632 50.7573 261.405 49.4712C259.179 48.1859 258.37 45.3685 259.576 43.0983L264.586 33.667Z",
    fill: "url(#paint7_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.169,
    cy: 36.0347,
    r: 4.61871,
    fill: "#3700D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M296.456 33.667C297.822 31.094 301.05 30.1677 303.573 31.6243C306.095 33.0802 306.908 36.3362 305.366 38.8061L299.711 47.8651C298.349 50.047 295.502 50.7573 293.275 49.4712C291.049 48.1859 290.24 45.3685 291.446 43.0983L296.456 33.667Z",
    fill: "url(#paint8_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.04,
    cy: 36.0347,
    r: 4.61871,
    fill: "#3700D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M328.326 33.667C329.693 31.094 332.921 30.1677 335.444 31.6243C337.966 33.0802 338.778 36.3362 337.236 38.8061L331.581 47.8651C330.219 50.047 327.373 50.7573 325.146 49.4712C322.919 48.1859 322.111 45.3685 323.317 43.0983L328.326 33.667Z",
    fill: "url(#paint9_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.909,
    cy: 36.0347,
    r: 4.61871,
    fill: "#3700D3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175.213,
    y: 28.9343,
    width: 135.789,
    height: 45.7112,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 184.624,
    y: 23.5576,
    width: 126.378,
    height: 51.0889,
    fill: "#3500CD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 192.02,
    y: 33.6419,
    width: 110.245,
    height: 33.6112,
    stroke: "white",
    strokeWidth: 1.34445
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 326.749,
    y: 177.581,
    width: 141.167,
    height: 44.3667,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 334.813,
    y: 161.006,
    width: 137.134,
    height: 60.5001,
    fill: "#3500CD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 322.013,
    width: 95.0978,
    height: 44.9871,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.76318,
    y: 307.806,
    width: 110.624,
    height: 59.1935,
    fill: "#14D3A6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 277.025,
    y: 322.013,
    width: 95.0978,
    height: 44.9871,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 284.789,
    y: 307.806,
    width: 110.624,
    height: 59.1935,
    fill: "#14D3A6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 414.354,
    y: 322.013,
    width: 95.0978,
    height: 44.9871,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 422.118,
    y: 307.806,
    width: 110.624,
    height: 59.1935,
    fill: "#14D3A6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 137.329,
    y: 307.806,
    width: 118.387,
    height: 59.1935,
    fill: "#E4E3E3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M147.499 317.25C148.865 314.677 152.093 313.751 154.616 315.207C157.138 316.663 157.951 319.919 156.409 322.389L150.754 331.448C149.391 333.63 146.545 334.34 144.318 333.054C142.092 331.769 141.283 328.952 142.489 326.681L147.499 317.25Z",
    fill: "url(#paint10_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.082,
    cy: 319.618,
    r: 4.61871,
    fill: "#3700D3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M179.369 317.25C180.735 314.677 183.964 313.751 186.487 315.207C189.008 316.663 189.821 319.919 188.279 322.389L182.624 331.448C181.262 333.63 178.416 334.34 176.188 333.054C173.962 331.769 173.153 328.952 174.359 326.681L179.369 317.25Z",
    fill: "url(#paint11_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.954,
    cy: 319.618,
    r: 4.61871,
    fill: "#3700D3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M211.239 317.25C212.606 314.677 215.834 313.751 218.357 315.207C220.879 316.663 221.691 319.919 220.149 322.389L214.494 331.448C213.132 333.63 210.286 334.34 208.059 333.054C205.832 331.769 205.024 328.952 206.23 326.681L211.239 317.25Z",
    fill: "url(#paint12_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.823,
    cy: 319.618,
    r: 4.61871,
    fill: "#3700D3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M243.109 317.25C244.476 314.677 247.704 313.751 250.227 315.207C252.749 316.663 253.561 319.919 252.02 322.389L246.364 331.448C245.002 333.63 242.156 334.34 239.929 333.054C237.703 331.769 236.894 328.952 238.1 326.681L243.109 317.25Z",
    fill: "url(#paint13_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.693,
    cy: 319.618,
    r: 4.61871,
    fill: "#3700D3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M147.499 345.663C148.865 343.09 152.093 342.164 154.616 343.62C157.138 345.076 157.951 348.332 156.409 350.802L150.754 359.861C149.391 362.043 146.545 362.753 144.318 361.467C142.092 360.182 141.283 357.365 142.489 355.094L147.499 345.663Z",
    fill: "url(#paint14_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.082,
    cy: 348.031,
    r: 4.61871,
    fill: "#3700D3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M179.369 345.663C180.735 343.09 183.964 342.164 186.487 343.62C189.008 345.076 189.821 348.332 188.279 350.802L182.624 359.861C181.262 362.043 178.416 362.753 176.188 361.467C173.962 360.182 173.153 357.365 174.359 355.094L179.369 345.663Z",
    fill: "url(#paint15_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.954,
    cy: 348.031,
    r: 4.61871,
    fill: "#3700D3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M211.239 345.663C212.606 343.09 215.834 342.164 218.357 343.62C220.879 345.076 221.691 348.332 220.149 350.802L214.494 359.861C213.132 362.043 210.286 362.753 208.059 361.467C205.832 360.182 205.024 357.365 206.23 355.094L211.239 345.663Z",
    fill: "url(#paint16_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.822,
    cy: 348.031,
    r: 4.61871,
    fill: "#3700D3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M243.109 345.663C244.476 343.09 247.704 342.164 250.227 343.62C252.749 345.076 253.561 348.332 252.02 350.802L246.364 359.861C245.002 362.043 242.156 362.753 239.929 361.467C237.703 360.182 236.894 357.365 238.1 355.094L243.109 345.663Z",
    fill: "url(#paint17_linear_214_2539)",
    fillOpacity: 0.47
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.693,
    cy: 348.031,
    r: 4.61871,
    fill: "#3700D3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.226 161.006V123.123H404.884V161.006",
    stroke: "black",
    strokeWidth: 2.36774
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1938 307.806V269.922H196.523V307.806",
    stroke: "black",
    strokeWidth: 2.36774
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M336.219 307.806V269.922H473.548V307.806",
    stroke: "black",
    strokeWidth: 2.36774
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M248.613 73.3999L248.613 123.122",
    stroke: "black",
    strokeWidth: 2.36774
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M127.858 220.2L127.858 269.923",
    stroke: "black",
    strokeWidth: 2.36774
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M404.884 220.2L404.884 269.923",
    stroke: "black",
    strokeWidth: 2.36774
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_2539",
    x1: 198.819,
    y1: 21.9259,
    x2: 206.622,
    y2: 8.45832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_214_2539",
    x1: 230.689,
    y1: 21.9259,
    x2: 238.492,
    y2: 8.45832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_214_2539",
    x1: 262.559,
    y1: 21.9259,
    x2: 270.363,
    y2: 8.45832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_214_2539",
    x1: 294.43,
    y1: 21.9259,
    x2: 302.234,
    y2: 8.45832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_214_2539",
    x1: 326.3,
    y1: 21.9259,
    x2: 334.104,
    y2: 8.45832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_214_2539",
    x1: 198.819,
    y1: 50.8847,
    x2: 206.622,
    y2: 37.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_214_2539",
    x1: 230.689,
    y1: 50.8847,
    x2: 238.492,
    y2: 37.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_214_2539",
    x1: 262.559,
    y1: 50.8847,
    x2: 270.363,
    y2: 37.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_214_2539",
    x1: 294.429,
    y1: 50.8847,
    x2: 302.233,
    y2: 37.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_214_2539",
    x1: 326.3,
    y1: 50.8847,
    x2: 334.104,
    y2: 37.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_214_2539",
    x1: 145.472,
    y1: 334.468,
    x2: 153.276,
    y2: 321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_214_2539",
    x1: 177.343,
    y1: 334.468,
    x2: 185.146,
    y2: 321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_214_2539",
    x1: 209.213,
    y1: 334.468,
    x2: 217.017,
    y2: 321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_214_2539",
    x1: 241.083,
    y1: 334.468,
    x2: 248.887,
    y2: 321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_214_2539",
    x1: 145.472,
    y1: 362.881,
    x2: 153.276,
    y2: 349.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_214_2539",
    x1: 177.343,
    y1: 362.881,
    x2: 185.146,
    y2: 349.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_214_2539",
    x1: 209.213,
    y1: 362.881,
    x2: 217.017,
    y2: 349.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_214_2539",
    x1: 241.083,
    y1: 362.881,
    x2: 248.887,
    y2: 349.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionalDesign);
export default __webpack_public_path__ + "static/media/FunctionalDesign.724d263f5003fe271deb5f8222a24f1a.svg";
export { ForwardRef as ReactComponent };